import type { Choice } from "@memorang/types/src/session/new-session";
import { Box } from "@memorang/ui";
import ChoicesList from "../../../choices/ChoicesList";

interface Props {
	choices: Choice[];
	isAnswered: boolean;
	selectedChoiceIds: string[];
	correctAnswerIds: string[];
	itemId: number;
	handleSelectChoice: (id: string) => void;
}

const ExploreAccordion = ({
	choices,
	isAnswered,
	selectedChoiceIds,
	correctAnswerIds,
	itemId,
	handleSelectChoice,
}: Props) => (
	<Box>
		<ChoicesList
			choices={choices}
			isAnswered={isAnswered}
			selectedChoiceIds={selectedChoiceIds}
			correctAnswerIds={correctAnswerIds}
			multiSelect
			handleSelectChoice={handleSelectChoice}
			itemId={itemId}
			crossedOutChoiceIds={[]}
		/>
	</Box>
);

export default ExploreAccordion;
